import { GetStaticProps, GetStaticPropsContext, NextPage, InferGetStaticPropsType, GetStaticPaths } from 'next'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
import { Fragment } from 'react'

import { DefaultLayout } from '~/shared/layouts/DefaultLayout'
import { COMMON_TRANSLATION_MODULE_NAMES, DEFAULT_LAYOUT_TRANSLATION_MODULE_NAMES } from '~/shared/layouts/constants'
import { usePageTitle } from '~/utils/tags'
import StudyTipsItem from '~/study-tips/pages/StudyTipsItem.page'
import { getStudyTipsCategoryDetails } from '~/../utils/data-fetch/study-tips/study-tips.query'

import Metatags from '~/components/Metadata/Metatags'

const StudyTipsItemPage: NextPage = ({
  itemData,
  itemKey,
}: InferGetStaticPropsType<typeof getStaticProps>): React.ReactElement => {
  const { name = '', metaDescription } = itemData

  return (
    <Fragment>
      <Metatags metaDescription={metaDescription} title={usePageTitle(name)} />
      <DefaultLayout zeroPadding>
        <StudyTipsItem itemData={itemData} itemKey={itemKey} />
      </DefaultLayout>
    </Fragment>
  )
}

export const getStaticProps: GetStaticProps = async ({ locale, params: { itemKey } }: GetStaticPropsContext) => {
  const itemData = await getStudyTipsCategoryDetails(locale ?? 'en', itemKey as string)

  if (!itemData) return { notFound: true }

  return {
    props: {
      ...(await serverSideTranslations(locale as string, [
        'studyTips',
        'generics',
        ...DEFAULT_LAYOUT_TRANSLATION_MODULE_NAMES,
        ...COMMON_TRANSLATION_MODULE_NAMES,
      ])),
      itemData,
      itemKey,
    },
  }
}

export const getStaticPaths: GetStaticPaths = () => {
  return {
    paths: [],
    fallback: 'blocking',
  }
}

export default StudyTipsItemPage
